import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {ErrorHandlingEffects} from './error-handling.effects';
import * as fromErrorHandling from './error-handling.reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromErrorHandling.errorHandlingFeatureKey, fromErrorHandling.reducer),
    EffectsModule.forFeature([ErrorHandlingEffects]),
  ],
})
export class ErrorHandlingModule {}
